import React, { useEffect, useState } from 'react'
import EmployerZoneTable from './../components/table/EmployerZone/index'
// import './style.css'
import addBtn from './../images/add-button.png'
import closeBtn from './../images/close-button.png'
import { editJob, postJob } from '../../../api'
import { Navigate } from 'react-router-dom';
import axios from 'axios'

function EmployerZone() {
  const [isAuth, setIsAuth] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [file, setFile] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [edit, setEdit] = useState(false)

  useEffect(() => {
    const isAuthenticated = () => {
      axios.get('https://job-portal-back123.herokuapp.com/auth/admin/verify', {
        credentials: "include",
        withCredentials: true,
        headers: {
          Authorization: localStorage.getItem("token")
        }
      }).then(res => {
        setIsAuth(true)
        setIsLoading(false)
      }).catch(err => {
        console.log(err)
        window.location = "/admin/signin"
      })
    }
    isAuthenticated()
  }, [])

  return (
    <>
          <EmployerZoneTable/>
    </>
  )
}

export default EmployerZone
